import { EntityAttendance } from "../../entity/EntityAttendance";

export class DtoAttendancesPostRes extends EntityAttendance {}
